import React from 'react';
import _ from 'underscore';
import DataList from 'components/ui/DataList';
import MarketsActionCreators from 'actions/MarketActionCreators';
import MarketsStore from 'stores/MarketsStore';
import SessionStore from 'stores/SessionStore';
import GeofenceMap from 'components/modules/locations/GeofenceMap';
import ToastStore from 'stores/ToastStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import unitConverter from 'convert-units';
import { withLocaleContext } from 'providers/locale-settings-context';
import AddButton from '../../v2/buttons/AddButton';
import Mapping from './Mapping';
import CreateMarketModal from './CreateMarketModal';
class List extends React.Component {
    constructor(props) {
        super(props);
        this.handleToastChange = () => {
            const notification = ToastStore.getLatestNotification();
            if (notification) {
                this.setState({
                    notification,
                });
            }
        };
        this.parseMarketsGeofence = (markets) => {
            const geofenceArray = markets.map((market) => {
                // Comes in as an array [lng , lat]
                return market.geofence.coordinates[0].map((points) => {
                    return { lng: points[0], lat: points[1] };
                });
            });
            return geofenceArray;
        };
        this.handleMarketsStoreChange = () => {
            const markets = MarketsStore.getMarkets();
            this.setState({ markets });
            this.setState({ latLongs: this.parseMarketsGeofence(markets) });
        };
        this.handleHide = () => {
            this.setState({ showCreateMarketModal: false });
        };
        this.handleCreateMarket = (marketData) => {
            const { localeData } = this.props;
            marketData = Object.assign(Object.assign({}, marketData), { distribution_radius: unitConverter(marketData.distribution_radius)
                    .from(localeData.distance_units)
                    .to('mi'), max_shipment_distance: unitConverter(marketData.max_shipment_distance)
                    .from(localeData.distance_units)
                    .to('mi') });
            MarketsActionCreators.createMarket(marketData);
        };
        this.handleEditMarket = (id, marketData) => {
            const { localeData } = this.props;
            marketData = Object.assign(Object.assign({}, marketData), { distribution_radius: unitConverter(marketData.distribution_radius)
                    .from(localeData.distance_units)
                    .to('mi'), max_shipment_distance: unitConverter(marketData.max_shipment_distance)
                    .from(localeData.distance_units)
                    .to('mi') });
            MarketsActionCreators.updateMarket(id, marketData);
        };
        this.handleSelectRow = (row) => {
            this.setState({ showCreateMarketModal: true, market: row });
        };
        this.mapComponent = () => {
            const MAP_REGION = {
                US: { lat: 37.0902, lng: -95.7129 },
                AP: { lat: 15.87, lng: 100.9925 },
            };
            return MAP_REGION.US;
        };
        this.state = {
            user: SessionStore.getUser(),
            errors: {},
            markets: [], // List of all Markets
            showCreateMarketModal: false,
            market: false, // Currently selected market, setting to false if not created >:() Sorrry!
            latLongs: [],
            notification: {},
        };
    }
    componentDidMount() {
        MarketsStore.addChangeListener(this.handleMarketsStoreChange); // Connecting to store
        ToastStore.addChangeListener(this.handleToastChange);
        MarketsActionCreators.findMarkets(); // API calls made from action creator
    }
    componentWillUnmount() {
        MarketsStore.removeChangeListener(this.handleMarketsStoreChange);
        ToastStore.removeChangeListener(this.handleToastChange);
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "" },
            React.createElement("div", null,
                React.createElement(CreateMarketModal, { onHide: this.handleHide, show: this.state.showCreateMarketModal, onCreate: this.handleCreateMarket, error: this.state.errors, market: this.state.market, onSave: this.handleCreateMarket, onEdit: this.handleEditMarket, markets: this.state.markets })),
            React.createElement("div", null,
                React.createElement(GeofenceMap, { height: 400, location: this.mapComponent(), zoom: 4, onPolygonComplete: () => { }, latLongs: this.state.latLongs, showMarker: "true" })),
            React.createElement("div", { className: "header flex p-4" },
                React.createElement("div", { className: "flex w-3/4" },
                    React.createElement("h3", { className: "mb-0 mt-2 mr-4" }, titleize(t('MARKET', { count: 2 }))),
                    React.createElement(AddButton, { onClick: () => this.setState({ showCreateMarketModal: true, market: false }) })),
                React.createElement("div", { className: "flex w-1/4 justify-end p-2" },
                    React.createElement("div", null,
                        React.createElement("b", null, t('SHOWING_MARKET_COUNT', {
                            count: this.state.markets.length,
                        }))))),
            React.createElement("div", { className: "p-4 shadow rounded bg-white" },
                React.createElement(DataList, { striped: true, showHeaders: true, clickToSelect: true, select: true, hideSelectColumn: true, onSelect: (row, selected) => this.handleSelectRow(row, selected), data: this.state.markets, columns: Mapping.columns, onSelectAll: () => { } }))));
    }
}
export default withTranslation()(withLocaleContext(List));
